<template>
  <b-card v-if="!!option" id="page-promotion-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title>
        <h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.promotions.title").toLowerCase() }}
        </h2>
      </b-card-title>
      <b-button variant="primary" @click="backButton">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>
    <b-card-body>
      <validation-observer ref="promotionform">
        <b-form>
          <b-row>
            <b-col class="p-0" cols="12" sm="6" md="6" lg="6" xl="6">
              <b-col cols="12">
                <b-form-group :label="$t(label('name'))" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('name'))"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="promotion.name"
                      :disabled="option === 2 ? true : false"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t(label('name'))"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('clients'))"
                  rules="required"
                >
                  <b-form-group
                    :label="$t(label('clients'))"
                    label-for="clients"
                    :state="errors.length > 0 ? false : null"
                  >
                    <v-select
                      v-model="promotion.clients"
                      input-id="clients"
                      :options="allClients"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :placeholder="$t(label('clients'))"
                      :disabled="!isSaveMode"
                      :taggable="false"
                      :reduce="(option) => option.idClient"
                      @search="searchClientsAll"
                      :filterable="false"
                      @open="onOpenClients"
                      multiple
                    >
                      <template #list-footer>
                        <li
                          v-show="hasNextPageClients"
                          ref="loadClients"
                          class="loader"
                        >
                          Cargando más opciones...
                        </li>
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-col>

            <b-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              xl="6"
              class="d-flex align-items-center justify-content-center"
            >
              <b-form-group
                :label="$t(label('flyer'))"
                label-for="inputFilePhoto"
              >
                <b-media class="body-style">
                  <div v-if="!promotion.urlFlyer">
                    <input
                      id="inputFilePhoto"
                      ref="fileInputPhoto"
                      name="inputFilePhoto"
                      type="file"
                      class="hidden"
                      accept=".png,.peg,.jpg,.jpeg"
                      @change="onFileChange($event, 'urlFlyer')"
                    />
                    <div
                      class="cursor-pointer m-auto cuve text-center border-2 d-flex align-items-center justify-content-center"
                      accept=".png,.peg,.jpg,.jpeg"
                      @drop="handleDrop($event, 'urlFlyer')"
                      @dragover="handleDragover"
                      @dragenter="handleDragover"
                      @click="$refs.fileInputPhoto.click()"
                    >
                      <feather-icon
                        icon="UploadCloudIcon"
                        size="20"
                        svg-classes="h-16 w-16 stroke-current text-grey"
                      />
                      <span
                        style="margin-left: 5px"
                        @click.stop="$refs.fileInputPhoto.click()"
                        >{{ $t(label("imahen")) }}
                      </span>
                    </div>
                  </div>

                  <template v-if="promotion.urlFlyer" #aside>
                    <div class="image-full-screen">
                      <img
                        id="image"
                        ref="image"
                        :src="promotion.urlFlyer"
                        class="img-avatar border-dashed"
                      />
                    </div>
                    <div
                      v-if="promotion.urlFlyer && option != 2"
                      class="d-flex flex-wrap"
                      style="width: 10px"
                    >
                      <b-button
                        variant="primary"
                        style="height: 30px; width: 30px; padding: 4px"
                        @click="deleteFile('urlFlyer')"
                      >
                        <feather-icon icon="XIcon" size="21" />
                      </b-button>
                    </div>
                  </template>
                </b-media>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('startDate'))"
                label-for="startDate"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('startDate'))"
                  rules="required"
                >
                  <b-form-datepicker
                    id="startDate"
                    ref="startDate"
                    v-model="promotion.startDate"
                    :placeholder="$t(label('startDate'))"
                    :state="errors.length > 0 ? false : null"
                    :disabled="!isSaveMode"
                    class="mr-2"
                    reset-button
                    dropright
                    :min="new Date()"
                  >
                  </b-form-datepicker>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('endDate'))" label-for="endDate">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('endDate'))"
                  rules="required"
                >
                  <b-form-datepicker
                    id="endDate"
                    ref="endDate"
                    v-model="promotion.endDate"
                    :placeholder="$t(label('endDate'))"
                    :state="errors.length > 0 ? false : null"
                    :disabled="!isSaveMode"
                    class="mr-2"
                    reset-button
                    dropright
                    :min="new Date()"
                  >
                  </b-form-datepicker>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('description'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('description'))"
                  label-for="description"
                >
                  <b-form-textarea
                    id="description"
                    v-model="promotion.description"
                    :placeholder="$t(label('description'))"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    rows="3"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('details'))"
                rules="required"
              >
                <b-form-group :label="$t(label('details'))" label-for="details">
                  <b-form-textarea
                    id="details"
                    v-model="promotion.details"
                    :placeholder="$t(label('details'))"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    rows="3"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";

import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BInputGroup,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BToast,
  BMedia,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { showLoading, stopLoading, getParams } from "@core/utils/utils";
import { required, integer } from "@validations";
import vSelect from "vue-select";

import { getCatalog } from "@core/api/request/catalogs";

import { postFile } from "@core/api/request/catalogs";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import { allClientsByCompany } from "@core/api/request/clients";
import { allServices } from "@core/api/request/services";
import { allEmployeesByCompany } from "@core/api/request/employees";
import {
  createOrEditPromotions,
  getPromotion,
} from "@core/api/request/promotions";
import flatPickr from "vue-flatpickr-component";

import moment from "moment";
const promotion = {
  idPromotion: null,
  guidCompany: null,
  name: null,
  startDate: null,
  endDate: null,
  urlFlyer: null,
  description: null,
  details: null,
  clients: [],
};
export default {
  components: {
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BToast,
    BFormInvalidFeedback,
    BMedia,
    BFormDatepicker,
    BFormTimepicker,
    VueTelInput,
    flatPickr,
  },

  directives: {
    Ripple,
  },
  data() {
    return {
      isSaveMode: true,
      companyGuid: null,
      required,
      integer,
      promotion: Object.assign(promotion),
      option: "",
      listRecurrency: [],
      photo: null,
      fileData: {},
      loading: false,

      inputTelOption: {
        placeholder: "Ingrese un número de teléfono",
        // showDialCode: true
      },
      openTelInput: false,

      allClients: [],

      currentPageClients: 1,
      perPageClients: 20,
      observerClients: null,
      searchClients: null,
      hasNextPageClients: true,
      loadingClients: false,
      totalPagesClients: null,
      allServices: [],
      currentPageServices: 1,
      perPageServices: 20,
      observerServices: null,
      searchServices: null,
      hasNextPageServices: true,
      loadingServices: false,
      totalPagesServices: null,
      allEmployees: [],
      currentPageEmployee: 1,
      perPageEmployee: 20,
      observerEmployee: null,
      searchEmployee: null,
      hasNextPageEmployee: true,
      loadingEmployee: false,
      totalPagesEmployee: null,
      minTime: "08:00",
      maxTime: "20:00",
      configStart: {
        enableTime: true,
        altInput: true,
        altFormat: "F j, Y  h:i K",
        dateFormat: "Y-m-dTH:i",
        minDate: null,
        minTime: "08:00",
        maxTime: "19:00",
        onOpen: this.minDateStart,
        // defaultDate: null,
      },
      configEnd: {
        enableTime: true,
        altInput: true,
        altFormat: "F j, Y  h:i K",
        dateFormat: "Y-m-dTH:i",
        minDate: null,
        minTime: "08:00",
        maxTime: "19:00",
        onOpen: this.minDateEnd,
        // defaultDate: null,
      },
    };
  },
  created() {
    localize("es");
  },
  computed: {},
  mounted() {
    this.promotion = {
      idPromotion: null,
      guidCompany: null,
      name: null,
      startDate: null,
      endDate: null,
      urlFlyer: null,
      description: null,
      details: null,
      clients: [],
    };
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.initialize();

    const observers = [
      { name: "clients", callback: this.infiniteScrollClients },
      { name: "employees", callback: this.infiniteScrollEmployees },
      { name: "services", callback: this.infiniteScrollServices },
    ];

    observers.forEach((observer) => {
      this[
        `observer${
          observer.name.charAt(0).toUpperCase() + observer.name.slice(1)
        }`
      ] = new IntersectionObserver(observer.callback);
    });
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.resetData();
      this.loadData();
    },
  },
  methods: {
    backButton() {
      this.onCancel();
      this.goBack();
    },

    deleteFile(field) {
      this.promotion[field] = null;
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },

    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      this.loadingPhoto = true;
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.promotion[field] = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            this.loadingPhoto = false;
            stopLoading();
          });
      });
    },

    resetData() {
      this.allClients = [];
      this.allServices = [];
      this.allEmployees = [];
      this.currentPageClients = 1;
      this.currentPageEmployee = 1;
      this.currentPageServices = 1;
      this.hasNextPageServices = true;
      this.hasNextPageEmployee = true;
      this.hasNextPageClients = true;
    },

    async loadData() {
      await Promise.all([
        this.loadClientsByCompanie(),
        this.loadEmployeeByCompanie(),
        this.loadServicesByCompanie(),
        this.loadRecurrency(),
      ]);
    },
    minDateStart() {
      this.configStart.minDate = new Date();
    },
    minDateEnd() {
      this.configEnd.minDate = new Date();
    },
    label(field) {
      return `pages.promotions.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    loadRecurrency() {
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,cb709850-b958-4596-9be9-1d76aacd1950`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          stopLoading();
          const data = _.get(resp, "data") || [];
          this.listRecurrency = data.listOfItems.items;
        })
        .catch((error) => {
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },

    async initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "promotions" }).catch(() => {});
      }

      await this.loadData();
      switch (this.option) {
        case 1:
          this.onCancel();
          this.promotion.guidCompany =
            this.$store.state.appConfig.activeCompanyGuid;
          break;
        // option 2 to show, option 3 to edit
        case 2:
          if (this.$route.params.idPromotion === undefined) {
            router.push({ name: "promotions" }).catch(() => {});
          }
          this.isSaveMode = false;
          await this.showPromotion(this.$route.params.idPromotion);

          break;
        case 3:
          if (this.$route.params.idPromotion === undefined) {
            router.push({ name: "promotions" }).catch(() => {});
          }

          this.isSaveMode = true;
          await this.showPromotion(this.$route.params.idPromotion);
          break;
      }
    },
    chargeParamsClients() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageClients}`);

      arrParams.push(`rows,${this.perPageClients}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      if (this.searchClients != null)
        arrParams.push(`name,${this.searchClients}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },
    async loadClientsByCompanie() {
      if (this.loadingClients || !this.hasNextPageClients) return;

      this.loadingClients = true;
      const param = this.chargeParamsClients();
      await allClientsByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.allClients = [...this.allClients, ...data?.items];
            this.currentPageClients = data?.currentPage;
            this.totalPagesClients = data?.totalPages || 0;
            this.hasNextPageClients =
              this.currentPageClients < this.totalPagesClients;
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.hasNextPageClients = false;
        })
        .finally(() => {
          this.loadingClients = false;
        });
    },

    async onOpenClients() {
      if (this.hasNextPageClients) {
        await this.$nextTick();
        this.observerClients.observe(this.$refs.loadClients);
      }
    },

    async searchClientsAll(value) {
      this.searchClients = value;
      this.allClients = [];
      this.currentPageClients = 1;
      this.hasNextPageClients = true;
      this.loadClientsByCompanie();
    },

    async infiniteScrollClients(values) {
      const value = values[0];

      console.log("infinity", value);
      if (value.isIntersecting) {
        this.currentPageClients++;
        await this.loadClientsByCompanie();
      }
    },

    chargeParamsServices() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageServices}`);

      arrParams.push(`rows,${this.perPageServices}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      if (this.searchServices != null)
        arrParams.push(`name,${this.searchServices}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },
    async loadServicesByCompanie() {
      if (this.loadingServices || !this.hasNextPageServices) return;

      this.loadingServices = true;
      const param = this.chargeParamsServices();

      await allServices(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.allServices = [...this.allServices, ...data?.items];
            this.currentPageServices = data?.currentPage;
            this.totalPagesServices = data?.totalPages || 0;
            this.hasNextPageServices =
              this.currentPageServices < this.totalPagesServices;
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.hasNextPageServices = false;
        })
        .finally(() => {
          this.loadingServices = false;
        });
    },

    async onOpenServices() {
      if (this.hasNextPageServices) {
        await this.$nextTick();
        this.observerServices.observe(this.$refs.loadServices);
      }
    },

    async searchServicesAll(value) {
      this.searchServices = value;
      this.allServices = [];
      this.currentPageServices = 1;
      this.hasNextPageServices = true;
      this.loadServicesByCompanie();
    },

    async infiniteScrollServices(values) {
      const value = values[0];

      if (value.isIntersecting) {
        this.currentPageClients++;
        await this.loadServicesByCompanie();
      }
    },

    chargeParamsEmployee() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageEmployee}`);

      arrParams.push(`rows,${this.perPageEmployee}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      if (this.searchEmployee != null)
        arrParams.push(`name,${this.searchEmployee}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },
    async loadEmployeeByCompanie() {
      if (this.loadingEmployee || !this.hasNextPageEmployee) return;

      this.loadingEmployee = true;
      const param = this.chargeParamsEmployee();

      await allEmployeesByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.allEmployees = [...this.allEmployees, ...data?.items];
            this.currentPageEmployee = data?.currentPage;
            this.totalPagesEmployee = data?.totalPages || 0;
            this.hasNextPageEmployee =
              this.currentPageEmployee < this.totalPagesEmployee;
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.hasNextPageEmployee = false;
        })
        .finally(() => {
          this.loadingEmployee = false;
        });
    },

    async onOpenEmployees() {
      if (this.hasNextPageEmployee) {
        await this.$nextTick();
        this.observerEmployee.observe(this.$refs.loadEmployee);
      }
    },

    async searchEmployees(value) {
      this.searchEmployee = value;
      this.allEmployees = [];
      this.currentPageEmployee = 1;
      this.hasNextPageEmployee = true;
      this.loadEmployeeByCompanie();
    },

    async infiniteScrollEmployees(values) {
      const value = values[0];

      if (value.isIntersecting) {
        this.currentPageEmployee++;
        await this.loadEmployeeByCompanie();
      }
    },

    onSubmit() {
      let startDateData = new Date(this.promotion.startDate);
      let endDateData = new Date(this.promotion.endDate);

      if (startDateData > endDateData) {
        this.alertToast(
          "danger",
          "Dato inválido",
          "La fecha inicial no puede ser mayor que la fecha final",
        );
        return;
      }

      this.$refs.promotionform.validate().then((success) => {
        if (success) {
          showLoading();

          let clients = this.promotion.clients.map((idCli) => ({
            idClient: idCli.idClient != null ? idCli.idClient : idCli,
          }));

          const data = {
            idPromotion: this.promotion.idPromotion,
            guidCompany: this.companyGuid,
            name: this.promotion.name,
            urlFlyer: this.promotion.urlFlyer,
            startDate: new Date(this.promotion.startDate).toISOString(),
            endDate: new Date(this.promotion.endDate).toISOString(),
            description: this.promotion.description,
            details: this.promotion.details,
            clients: clients,
          };

          createOrEditPromotions(data, this.promotion.idPromotion)
            .then((resp) => {
              stopLoading();
              if (resp.data.err) {
                this.alertToast("danger", `${resp.data.message}`);
                return;
              }
              this.alertToast("success", `${resp.data.message}`);
              this.goBack();
            })
            .catch((error) => {
              stopLoading();
              this.alertToast("danger", "Error", error.message);
              stopLoading();
            });
        }
      });
    },
    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },
    async showPromotion(id) {
      showLoading();
      await getPromotion(id)
        .then((resp) => {
          const promotion = _.get(resp, "data");
          this.promotion = Object.assign(this.promotion, {
            idPromotion: promotion.idPromotion || null,
            guidCompany: promotion.guidCompany || null,
            name: promotion.name || null,
            startDate: promotion.startDate || null,
            endDate: promotion.endDate || null,
            urlFlyer: promotion.urlFlyer || null,
            description: promotion.description || null,
            details: promotion.details || null,
            clients: promotion.clients || null,
          });

          stopLoading();
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },

    onCancel() {
      this.promotion = Object.assign({
        idPromotion: null,
        guidCompany: null,
        name: null,
        startDate: null,
        endDate: null,
        urlFlyer: null,
        description: null,
        details: null,
        clients: [],
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
    localToUTC(localDate) {
      const date = new Date(localDate);
      return new Date(
        date.getTime() + date.getTimezoneOffset() * 60000,
      ).toISOString();
    },
    utcToLocal(utcDate) {
      const date = new Date(utcDate);
      return new Date(
        date.getTime() - date.getTimezoneOffset() * 60000,
      ).toLocaleString();
    },

    goBack() {
      this.$refs.promotionform.reset();
      router.back();
    },
  },
};
</script>

<style></style>
